<template>
  <div class="socialhubdraftswrapper">
    <div class="post-count-changed" v-if="newPost.length > 0" @click="refreshInfinite">{{ newPost.length }} {{ $t("components.socialhub.socialHubFeed.newPost") }}</div>

    <div class="social-hub-container">
      <transition-group name="list-complete" tag="div">
        <PostCard v-for="(post, index) in draftList.filter(x => x.isDraft == true)" :key="post.id + '-' + index" :post="post" />
      </transition-group>
      <infinite-loading @infinite="getData" :identifier="infiniteId">
        <div slot="no-more">
          <span> {{ $t("components.socialhub.socialHubFeed.noMorePosts") }}</span>
        </div>

        <div slot="no-results">
          <HolaconLottieNoData class="w-100" key="create-loading" :source="'holacon-social-hub-lottie-v2'" :title="'Social Hub'" @btnAdd="false" @btnRefresh="refreshInfinite" :buttonAdd="false" :buttonRefresh="true" :loading="loading" />
          <!-- <span> {{ $t("components.socialhub.socialHubFeed.noPostShared") }} </span> -->
        </div>
      </infinite-loading>
    </div>
  </div>
</template>

<script>
import PostCard from "@/components/socialhub/NewPostCard.vue";

export default {
  name: "SocialHubDrafts",
  components: { PostCard },
  data() {
    return {
      infiniteId: +new Date(),
      commentReply: false,
      timeout: null,
      loading: false,
      newPost: []
    };
  },

  computed: {
    filter() {
      return this.$store.state.socialhub.filter;
    },
    draftList() {
      return this.$store.getters.getSocialHubList;
    },
    draftInfiniteId() {
      return this.$store.getters.getDraftInfiniteId;
    }
  },
  async created() {
    this.$store.commit("clearPostList");
    this.filter.skip = 0;
    this.filter.take = 10;
    var channelId = "event-social-hub-" + this.$store.state.event.event.id;
    this.$socket.off(channelId + "-removePost");
    this.$socket.on(channelId + "-removePost", data => {
      var fIndex = this.draftList.findIndex(x => x.id == data.data.PostId);
      if (fIndex != -1) {
        this.draftList.splice(fIndex, 1);
      }
    });
    this.$socket.on(channelId + "-newPost", data => {
      var socketData = this.$toCamel(data.data.Post);
      var fIndex = this.postList.findIndex(x => x.id == socketData.id);
      if (fIndex == -1) {
        this.newPost.unshift(data.data);
      }
    });
  },
  beforeDestroy(){
    var channelId = "event-social-hub-" + this.$store.state.event.event.id;
    this.$socket.off(channelId + "-newPost");
    this.$socket.off(channelId + "-removePost");
  },

  methods: {
    refreshInfinite() {
      this.loading = "loadingList";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.filter.skip = 0;
        this.filter.take = 10;
        this.$store.commit("clearPostList");
        this.infiniteId += 1;
        this.loading = false;
      }, 500);
    },
    async getData($state) {
      this.filter.isDraft = true;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("socialHubList", { ...this.filter });
        if (res.data.data.items.length > 0) {
          this.filter.skip = this.filter.take;
          this.filter.take = this.filter.skip * 2;
          this.$store.commit("setPostList", res.data.data.items);
          $state.loaded();
        } else {
          $state.complete();
        }
      }, 500);
    },
    commentChanged(status) {
      this.commentReply = status;
    }
  }
};
</script>

<style scoped lang="less">
.socialhubdraftswrapper {
  height: 100%;
  width: 100%;
  padding: 0px 0px;
  position: relative;
  overflow: hidden;

  .post-count-changed {
    position: absolute;
    top: 3rem;
    cursor: pointer;
    left: calc(~"50% - 60px");
    width: 120px;
    color: white;
    padding: 5px;
    text-align: center;
    background-color: #03658c;
    border-radius: 1rem;
  }

  .feed-container {
    height: 100%;
    max-height: calc(~"100vh - 38px");
    overflow-y: scroll;
    overflow-x: hidden;
    padding: 0px 8px;
    padding-bottom: 100px;
  }
  .social-hub-container {
    width: 100%;
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    padding: 0px 10px;
    overflow-y: auto;
    overflow-x: hidden;
    max-height: calc(~"100vh - 90px");
    padding-bottom: 100px;

    gap: 10px;
    & > div {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/socialhub/SocialHubDrafts.vue